export default __webpack_public_path__ + "static/media/i152vp.9b3eccd4.webp";